import { api } from '../configs/axiosConfigs';

export const deleteCommentNoteEntry = async (property_id: string, comment_id: string, note_entry_id: string) => {
  return await api.delete(`/properties/${property_id}/comments/${comment_id}/note_entries/${note_entry_id}`);
};
